import React from "react";

import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import LoadingGif from "../../../components/visual/LoadingGif";
import MainTabButton from "../../../components/inputs/MainTabButton";
import MainTextField from "../../../components/inputs/MainTextField";

import { Box, Divider, Grid, IconButton, Modal, Typography } from "@mui/material";
import { defaultRequest } from "../../../utils/request/request";
import { handleChangeText } from "../../../utils/handleChange";


class UserSalesRegionPopup extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoadingUserComissionPolicy: true,

            userComissionPolicy: {
                fantasia: null
            }
        }
    }

    componentDidMount() {
        this.searchSingleUserComissionPolicy()
    }

    editSingleUserComissionPolicy = () => {
        this.setState({ isLoadingUserComissionPolicy: true }) 

        let config = {
            method: 'post',
            endpoint: 'financial/commissionpolicies'
        }
        let form = {
            type: 'Edit',
            id: this.props.sellerObject.idpolcomissao,
            infos: {
                despolitica: this.state.userComissionPolicy.despolitica,
                percomissao: this.state.userComissionPolicy.percomissao,
                percomnovos: this.state.userComissionPolicy.percomnovos,
            },
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({ isLoadingUserComissionPolicy: false })
                this.props.showAlert(r.data.message, 'success')
            } else {
                this.props.showAlert(r.data.message, 'error')
                this.setState({ isLoadingUserComissionPolicy: false })
            }
        })
    }

    handleChangeText = (event) => {
        handleChangeText(this.state.userComissionPolicy, event.target.id, event.target.value, () => this.props.handleChangeTab())
    }

    searchSingleUserComissionPolicy = () => {
        let config = {
            method: 'get',
            endpoint: 'represented/comissionpolicy'
        }
        let form = {
            idpolcomissao: this.props.comissionPolicyId,
        }
        defaultRequest(config, form).then((r) => {
            if (r.status) {
                this.setState({
                    userComissionPolicy: r.data.comissionPolicy,

                    isLoadingUserComissionPolicy: false
                }, () => this.props.handleChangeTab())
            } else {
                this.setState({
                    alertMessage: r.data.message,
                    alertType: 'error',
                    showAlert: true,
                }, () => this.props.handleChangeTab())
            }
        })
    }


    render() {
        if (this.state.isLoadingUserComissionPolicy) {
            return (
                <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box style={styles.popUpContainer}>
                        <LoadingGif />
                    </Box>
                </Modal>
            )
        }
        return (
            <Modal open={this.props.isOpen} onClose={this.props.closePopup} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box style={styles.popUpContainer}>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography>Dados Políticas de Comissões</Typography>
                        <IconButton onClick={this.props.closePopup}>
                            <CloseOutlinedIcon />
                        </IconButton>
                    </Box>

                    <Grid container columnSpacing={1} rowSpacing={4} sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' } }}>

                        <Grid item md={12}><Divider /></Grid>

                        <Grid item md={2}><MainTextField {...this.props} id='sellerObject.idpolcomissao' value={this.props.comissionPolicyId} label='Código' width='100%' disabled={true} /></Grid>
                        <Grid item md={8}></Grid>

                        <Grid item md={12}><MainTextField {...this.props} id='despolitica' value={this.state.userComissionPolicy.despolitica} label='Descrição da Política' handleChange={this.handleChangeText} width='100%' /></Grid>

                        <Grid item md={3}><MainTextField required {...this.props} id='percomissao' value={this.state.userComissionPolicy.percomissao} label='Comissão Carteira (%)' handleChange={this.handleChangeText} width='100%' type='percent' /></Grid>
                        <Grid item md={3}><MainTextField required {...this.props} id='percomnovos' value={this.state.userComissionPolicy.percomnovos} label='Comissão Novos (%)' handleChange={this.handleChangeText} width='100%' type='percent' /></Grid>

                        <Grid item md={4}></Grid>

                        <Grid item md={2}>
                            <MainTabButton sx={{ width: { xs: '100%', sm: '100%', md: '95%' } }} {...this.props} onButtonClick={this.editSingleUserComissionPolicy} title="Salvar" />
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        )
    }
}

export default UserSalesRegionPopup;

const styles = {
    popUpContainer: {
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        width: '80%',
        height: '35vh',
        maxWidth: '900px',
        maxHeight: '90vh',
        overflowY: 'auto',
    },
}